<template>
    <div class="info-item info-block" :class="[{ 'photos-item-puzzle': isPuzzle }]">
        <div class="info-item-body">
            <div class="feed-image" :class="isPuzzle ? 'feed-puzzle' : 'feed-photo'" @click="open" :style="{
                'background-image': photo.image ? 'url(' + photo.image + ')' : '',
            }">
                <div v-if="isPuzzle && photo.bought" @click.stop="$modal.show('puzzle', { photoId: photo.id })"
                    class="button-yellow-gradient bought">
                    {{ $t("feed.continueAssembling") }}
                </div>
                <div v-else-if="isPuzzle && !photo.bought && !initIsEmpty('init') && init.costs
                    " @click.stop="buy" :class="{ loader: buyLoader }" class="button-yellow-gradient new">
                    <span>
                        {{ $t("feed.buy") }}
                    </span>
                    <span v-if="!buyLoader" class="feed-puzzle-price">
                        {{ puzzlePrice }}
                    </span>
                </div>
            </div>
        </div>
        <div class="info-item-footer">
            <div v-if="!isPuzzle" class="feed-photo-comments" @click="open">
                {{ photo.comment_count }}
            </div>
            <div v-if="!isPuzzle" @click="vote" class="feed-photo-likes" :class="{
                'feed-photo-loader': voteLoader,
                'feed-photo-liked': photo.liked,
            }">
                {{ photo.likes }}
            </div>
            <div class="info-right">
                <redirectButton pathname="profile" :params="{ id: photo.owner.id }" :html="photo.owner.name"
                    class="info-author"></redirectButton>
                <div class="info-time">
                    {{ getVerbalDate(photo.time * 1000) }}
                </div>
                <redirectButton pathname="profile" :params="{ id: photo.owner.id }" :html="''" :style="{
                    'background-image': photo.owner.avatar
                        ? 'url(' + photo.owner.avatar + ')'
                        : '',
                }" class="info-avatar" :class="{ 'no-avatar': !photo.owner.avatar }"></redirectButton>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import redirectButton from "@/components/Buttons/Redirect";
import { formatDateTime } from "@/mixins/formatDateTime";

export default {
    name: "Feed",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
    },
    mixins: [formatDateTime],
    props: {
        photo: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            initialHeight: 0,
            maxHeight: 240,
            showLink: false,
            textShort: false,
            buyLoader: false,
            voteLoader: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userIsEmpty: "user/isEmpty",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
        }),
        isPuzzle: function () {
            return this.photo.album.album_type == 2;
        },
        puzzlePrice() {
            if (this.user.vip) {
                return Math.ceil(
                    (this.init.costs.puzzle_price *
                        (100 - this.init.costs.vip_discount)) /
                    100
                );
            }
            return this.formatPrice(this.init.costs.puzzle_price);
        },
    },
    methods: {
        formatPrice(price) {
            let arr = price.split(".");
            return arr[1] == "00" ? arr[0] : price;
        },
        open() {
            this.$modal.show("photo-details", {
                id: this.photo.id,
                isAlbum: true,
                feed: true,
                fromEvents: true,
            });
        },
        vote() {
            if (this.userIsEmpty("user")) {
                this.$modal.show("welcome");
                return;
            }
            this.voteLoader = true;
            this.$store
                .dispatch("home/vote", { id: this.photo.id, type: "photos" })
                .then(() => {
                    this.voteLoader = false;
                })
                .catch(() => {
                    this.voteLoader = false;
                });
        },
        buy() {
            if (parseFloat(this.puzzlePrice) > parseFloat(this.user.balance)) {
                this.$modal.show("dialog", {
                    title: this.$t("photoDetails.insufficientFunds"),
                    text: this.$t("photoDetails.notEnoughMoneyBuyPuzzle"),

                    buttons: [
                        {
                            title: this.$t("photoDetails.replenishBalance"),
                            handler: () => {
                                this.$modal.hide("dialog");
                                this.$modal.show("balance-in");
                            },
                        },
                        {
                            title: this.$t("photoDetails.close"),
                        },
                    ],
                });
                return;
            }
            this.buyLoader = true;
            this.$store
                .dispatch("puzzles/buy", this.photo.id)
                .then(() => {
                    this.buyLoader = false;
                    this.$store.dispatch("home/setBought", this.photo.id);
                    this.$modal.show("puzzle", { photoId: this.photo.id });
                })
                .catch(() => {
                    this.buyLoader = false;
                });
        },
    },
};
</script>
